import { createContext } from 'react';
import type { Brand } from '../types/store';

export const BrandContext = createContext<Brand | null>(null);
